export const getKeywords = "get/keywords";
export const getTopics = "get/topics";
export const getAuthors = "get/Authors"
export const deleteTag = "delete/tags"
export const deleteTopic = "delete/topics";
